import { getPushConfig, getChannelList, pushConfigSave, getTemplateList, saveTemplate, getPublishList,
  getArticleListTop5 } from '../../services/webSiteSetUp/homeSetting';

const initState = {
  activeModel: 0,
  background: '',
  banners: [],
  contentList: [],
  title: '',
};

export default {
  namespace: 'homeSetting',
  state: initState,
  effects: {
    *fetchPushConfigSave({ params }, { call }) {
      try {
        const response = yield call(pushConfigSave, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.message || '网络错误，请重试');
      }
    },
    *fetchPushConfigInfo({ params }, { call }) {
      try {
        const response = yield call(getPushConfig, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.message || '网络错误，请重试');
      }
    },
    *fetchTemplateList({ params }, { call }) {
      try {
        const response = yield call(getTemplateList, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.message || '网络错误，请重试');
      }
    },
    *fetchSaveTemplate({ params }, { call }) {
      try {
        const response = yield call(saveTemplate, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.message || '网络错误，请重试');
      }
    },
    *fetchChannelList({ params }, { call }) {
      try {
        const response = yield call(getChannelList, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.message || '网络错误，请重试');
      }
    },
    *fetchPublishList({ params }, { call }) {
      try {
        const response = yield call(getPublishList, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.message || '网络错误，请重试');
      }
    },
    *fetchArticleListTop5({ params }, { call }) {
      try {
        const response = yield call(getArticleListTop5, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.message || '网络错误，请重试');
      }
    },
    *saveContentList({ payload }, { put }) {
      yield put({
        type: 'saveState',
        payload,
      });
    },
  },

  reducers: {
    saveState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return {
        ...initState,
      };
    },
  },
};
